 
import React, { Fragment } from 'react';


export const RootElement = ({ children }) => {
  return (
    <Fragment>
      <div>{children}</div>
    </Fragment>
  );
};
